import { render, staticRenderFns } from "./SetupCustomerIdFormat.vue?vue&type=template&id=286e41b4&scoped=true"
import script from "./SetupCustomerIdFormat.vue?vue&type=script&lang=js"
export * from "./SetupCustomerIdFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e41b4",
  null
  
)

export default component.exports